"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toColorString = _interopRequireDefault(require("polished/lib/color/toColorString"));

var _styledComponents = require("styled-components");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default(color) {
  return (0, _styledComponents.css)(["box-shadow:inset 0 0 0 2px ", ";"], typeof color === 'string' ? color : (0, _toColorString.default)(color));
};

exports.default = _default;